import {
  Grid,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  styled
} from '@mui/material'

const StyledToggleButton = styled(ToggleButton)({
  padding: '10px 20px'
})

const ToggleNotice = ({noticeType, onChangeNoticeType}) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" spacing={2} alignItems="center">
        <ToggleButtonGroup
          color="standard"
          value={noticeType}
          exclusive
          onChange={onChangeNoticeType}
        >
          <StyledToggleButton value="Y">정</StyledToggleButton>
          <StyledToggleButton value="N">부</StyledToggleButton>
        </ToggleButtonGroup>
        <Typography variant="caption" component="div">로그인 인증 알림톡 발송을 위해 정/부 담당자 사항을 체크해주세요.</Typography>
      </Stack>
    </Grid>
  )
}

export default ToggleNotice